import { FC } from "react"

export const LoadingPage: FC = () => {
  return (
    <div>
      <p>Loading</p>
    </div>
  )
}
